<template>
    <div class="pa-4">
        <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1"
            :search="search"
        >
            <template v-slot:top>
            <v-toolbar flat>
                <v-toolbar-title>Menus</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>                
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="800px">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on" v-if="$store.state.currentPagePriv.create">
                      New Menu
                    </v-btn>
                </template>
                <v-card>
                    <v-card-title>
                    <span class="text-h5">{{ formTitle }}</span>
                    </v-card-title>
                    <v-divider></v-divider>

                    <v-card-text>
                    <v-container>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-row>
                        <v-col cols="12" sm="6" md="6">
                            <span>Parent</span>
                            <v-select filled rounded dense :items="menuparents" v-model="editedItem.parent_id" :rules="reqRule" hide-details="auto"></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <span>Menu Name</span>
                            <v-text-field v-model="editedItem.menu_name" filled rounded dense hide-details="auto" :rules="reqRule"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <span>Menu URL</span>
                            <v-text-field v-model="editedItem.menu_url" filled rounded dense hide-details="auto" :rules="reqRule"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <span>Sort</span>
                            <v-text-field v-model="editedItem.sort" filled rounded dense hide-details="auto" :rules="reqRule"></v-text-field>
                        </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                    </v-card-text>
                    <v-divider></v-divider>

                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">
                        Cancel
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="save">
                        Save
                    </v-btn>
                    </v-card-actions>
                </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                    <v-card-title class="body-1 text-center">Anda akan menghapus menu ini?</v-card-title>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                    <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDetail" max-width="600px">
                <v-card>
                    <v-card-title class="">
                    <span class="text-h6">Menu Detail</span>
                    <v-spacer></v-spacer>
                    <v-icon color="white" @click="dialogDetail = false">mdi-close</v-icon>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="pt-4">
                    <v-container>
                        <v-row>
                          <v-col cols="4" class="font-weight-bold">ID:</v-col>
                          <v-col cols="8">{{ detailItem.id }}</v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="4" class="font-weight-bold">Parent:</v-col>
                          <v-col cols="8">{{ detailItem.parent_id }}</v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="4" class="font-weight-bold">Menu Name:</v-col>
                          <v-col cols="8">{{ detailItem.menu_name }}</v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="4" class="font-weight-bold">URL:</v-col>
                          <v-col cols="8">{{ detailItem.menu_url }}</v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="4" class="font-weight-bold">Sort:</v-col>
                          <v-col cols="8">{{ detailItem.sort }}</v-col>
                        </v-row>
                    </v-container>
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialogDetail = false">
                        Close
                    </v-btn>
                    </v-card-actions>
                </v-card>
                </v-dialog>
            </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="viewDetail(item)">
                mdi-eye
            </v-icon>
            <v-icon small class="mr-2" @click="editItem(item)" v-if="$store.state.currentPagePriv.update">
                mdi-pencil
            </v-icon>
            <v-icon small @click="deleteItem(item)" v-if="$store.state.currentPagePriv.delete">
                mdi-delete
            </v-icon>
            </template>
            <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">
                Reset
            </v-btn>
            </template>
        </v-data-table>
    </div>
</template>

<script>
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      dialogDetail: false,
      detailItem: {},
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Parent', value: 'parent_id' },
        { text: 'Menu Name', value: 'menu_name' },
        { text: 'URL', value: 'menu_url' },
        { text: 'Sort', value: 'sort' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      items: [],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      reqRule: [v => !!v || 'Harus diisi!'],
      search: '',
      valid: true
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Menu' : 'Edit Menu'
      },
      menuparents() {
        return this.$store.state.menu.menuparents
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      async initialize () {
        let url = this.$store.state.config.apiHost + "menus" 
        let response = await this.$axios.get(url, {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
        console.log(response.data.data)
        if (response.data.status=='success') this.items = response.data.data
      },

      viewDetail(item) {
        this.detailItem = Object.assign({}, item);
        this.dialogDetail = true;
      },

      editItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      async deleteItemConfirm () {
        let url = this.$store.state.config.apiHost + "menus/" + this.editedItem.id
        let response = await this.$axios.delete(url, {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
        if (response.data.status=='success') this.items.splice(this.editedIndex, 1)
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      async save () {
        await this.$refs.form.validate();
        if (!this.valid) return;

        if (this.editedIndex > -1) {
          let url = this.$store.state.config.apiHost + "menus/" + this.editedItem.id
          let response = await this.$axios.put(url, JSON.stringify(this.editedItem), {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
          if (response.data.status=='success') Object.assign(this.items[this.editedIndex], this.editedItem)

          
        } else {
          let url = this.$store.state.config.apiHost + "menus"
          let response = await this.$axios.post(url, JSON.stringify(this.editedItem), {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
          if (response.data.status=='success') {
            this.editedItem.id = response.data.data.id
            this.items.push(this.editedItem)
          }
        }
        this.close()
      },
    },
  }
</script>

<style>
.v-text-field fieldset, .v-text-field .v-input__control, .v-text-field .v-input__slot {
    border-radius: 7px!important;
}

</style>